import React, { useState } from "react";
import {
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { FontFamily } from "../../styles/appStyles";
import coda from "../coda";

export const FooterColumn = ({ title, links }) => {
  const columnLinks = links || [];
  const [hoveredLink, setHoveredLink] = useState(null);

  const openLink = (url) => {
    if (url) {
      Linking.openURL(url);
    }
  };

  return (
    <View style={styles.column}>
      {!!title && <Text style={styles.title}>{title}</Text>}

      <View style={styles.list}>
        {columnLinks.map((link) => {
          const isCodaLink = link.name?.toLowerCase()?.includes("coda");
          if (isCodaLink) {
            return (
              <TouchableOpacity
                activeOpacity={0.8}
                key={link.name}
                onMouseEnter={() => setHoveredLink(link.name)}
                onMouseLeave={() => setHoveredLink(null)}
                onPress={() => openLink(link.url)}
                style={[{ display: "flex", flexDirection: "row", gap: 1 }]}
              >
                <Text style={[styles.link, { color: coda.C }]}>C</Text>
                <Text style={[styles.link, { color: coda.O }]}>O</Text>
                <Text style={[styles.link, { color: coda.D }]}>D</Text>
                <Text style={[styles.link, { color: coda.A }]}>A</Text>
              </TouchableOpacity>
            );
          }
          return (
            <TouchableOpacity
              activeOpacity={0.8}
              key={link.name}
              onMouseEnter={() => setHoveredLink(link.name)}
              onMouseLeave={() => setHoveredLink(null)}
              onPress={() => openLink(link.url)}
              style={styles.listItem}
            >
              <Text
                style={[
                  styles.link,
                  hoveredLink === link.name && styles.linkHover,
                ]}
              >
                {link.name}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  column: {},
  title: {
    color: "#9a9384",
    fontFamily: FontFamily.interBold,
    fontSize: 12.8,
    fontWeight: "700",
    letterSpacing: 2.56,
    maxWidth: 150,
    textTransform: "uppercase",
  },
  list: {
    marginTop: 20,
  },
  listItem: {
    marginTop: 12,
  },
  link: {
    color: "#2c2a24",
    fontFamily: FontFamily.interRegular,
    fontSize: 15,
    fontWeight: "400",
    lineHeight: 21,
  },
  linkHover: {
    color: "#0f9e7a",
    textDecorationLine: "underline",
  },
});
